import venueService from "./venueService";
import { network } from "venuescanner-js/schemas/serviceSchema.json";

import { urls } from "venuescanner-js/services/endPoints";

/** @class
 * @name Network
 * @desc Class definition of a Network - schema defined in venuescanner-js/schemas/serviceSchema.json
 */
class Network {
  constructor(values = {}) {
    Object.keys(network).forEach((key) => {
      this[key] = values[key];
    });
    this._venues = null;
  }
}

export default Network;
